import { Capacitor } from '@capacitor/core';

/** Native builds carry the actually-installed version; a web build has no App plugin, so it falls back to the build-time constant — same pattern as VersionCheckManager.jsx/SentryService.js. Shared by the online and offline suggestion/report flows so both stamp the version the same way. */
export async function getAppVersion() {
    if (Capacitor.isNativePlatform()) {
        try {
            const { App } = await import('@capacitor/app');
            const info = await App.getInfo();
            return info.version;
        } catch {
            // Fall through to the build-time constant below.
        }
    }
    return process.env.REACT_APP_VERSION || null;
}

export function getPlatform() {
    return Capacitor.getPlatform();
}
